<template>
  <main>
    <c-container class="my-3">
      <c-row class="my-3">
        <c-col>
          <h2>Strona główna - Warzywa Damian i Dominika Trójmiasto</h2>
        </c-col>
      </c-row>
      <c-row class="my-5">
        <c-col>
          <the-main-carousel/>
        </c-col>
      </c-row>
      <c-row class="my-5">
        <c-col class="col-md-6 col-12">
          <c-img fluid src="../veggies.png"></c-img>
        </c-col>
        <c-col class="col-md-6 col-12">
          <p class="lead font-2xl font-weight-bolder">
            Dowozimy świeże warzywa, owoce i przetwory do klientów z
            Trójmiasta i okolic.
          </p>
          <p class="lead font-xl">
            Dzięki tej stronie, możesz sprawdzić zawsze aktualną listę
            dostępnych towarów oraz złożyć zamówienie z dowozem.
            Dostarczamy świeże produkty w każdą środę i sobotę.
          </p>
          <p class="lead font-xl">
            <strong>Dla zamówień od min. {{ $store.state.minFreeDelivery }} zł
              - dowóz gratis!</strong>
          </p>
          <c-button color="primary" size="lg" to="/products">Zobacz dostępne
            towary
          </c-button>
        </c-col>
      </c-row>
    </c-container>
  </main>
</template>
<script>
import TheMainCarousel from '@/components/singleton/TheMainCarousel'

export default {
  name: 'MainPage',
  components: {TheMainCarousel}
}
</script>